<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
        <vs-button color="#1E90FF" type="filled" icon-pack="feather" icon="icon-plus" @click="$router.push(`/faturas/nova-fatura`).catch((err) => {})" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-primary">Nova Fatura</vs-button>
        <vs-button type="filled" icon-pack="feather" icon="icon-send"   @click="$router.push(`/faturas/enviadas`).catch((err) => {})" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success">Enviadas</vs-button>
        <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"  @click="$router.push(`/faturas/retorno`).catch((err) => {})" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-warning">Retorno</vs-button>
        </div>
      </div>
 <vue-good-table
        ref="my-table"
        selectionInfoClass="mytable"
        style="width: 100%"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          trigger: '',
          placeholder: 'Procurar',
          skipDiacritics: true,
        }"
        :pagination-options="paginationOptions"
        :columns="columns"
        :rows="invoices"
        @on-row-click="onRowClick"
      >
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="invoice">
          <span class="font-medium" v-if="invoice.column.field == 'idInvoice'">
               <vs-chip color="#1E90FF">{{invoice.row.idInvoice }}</vs-chip>
          </span>
          <span
            class="font-medium"
            v-if="invoice.column.field == 'corporateName'"
            @click.stop="open(invoice.row.idInvoice)">
           
            {{ invoice.row.corporateName }}
          </span>
          <span class="font-medium" v-if="invoice.column.field == 'recipient1'">
            {{ invoice.row.recipient1 }} {{ invoice.row.recipient2 }}
          </span>
          <span class="font-medium" v-if="invoice.column.field == 'paid'">
            <div v-show="invoice.row.paid=='Yes'">
             <vs-chip color="success">Sim</vs-chip>
            </div>
             <div v-show="invoice.row.paid=='No'">
             <vs-chip color="danger">Não</vs-chip>
            </div>
          </span>
           <span class="font-medium" v-if="invoice.column.field == 'nossoNumero'">
            {{ invoice.row.nossoNumero }}
           </span>
             <span class="font-medium" v-if="invoice.column.field == 'status'">
              <vs-chip color="danger">{{ invoice.row.status }}</vs-chip>
           </span>
           <span class="font-medium" v-if="invoice.column.field == 'createAt'">
             {{ invoice.row.createAt }}
          </span>
           <span class="font-medium" v-if="invoice.column.field == 'action'">
             <vs-button color="#1E90FF" type="filled" icon-pack="feather" icon="icon-send" @click="sendInvoiceByEmail(invoice.row.idInvoice)">Enviar</vs-button>
          </span>
        </template>
      </vue-good-table>
      <div class="vx-row">
      <div class="vx-col md:w-1/6 w-1/6 mt-5">
        <vs-button color="warning" type="filled" v-show="invoices.length > 0" @click="sendUnsentInvoices"
          >Enviar Todos</vs-button
        >
      </div>
    </div>
  </div>
</template>

 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { VueGoodTable } from "vue-good-table";
export default {
  components: {VueGoodTable},
  data() {
    return {
      invoices: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    }; 
  },
  computed: {
  
  },
  methods: {
     open(idInvoice) {
      this.$router.push(`/faturas/editar/${idInvoice}`).catch((err) => {});
    },
     async sendUnsentInvoices() {
      let invoices = this.invoices
      try {
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/invoice/sendUnsentInvoices`, invoices 
        );
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Enviado",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel enviar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
       this.loadInvoices();
    },
     onRowClick(params) {
   
     // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idInvoice",
          tdClass: "align-middle"
        },
        {
          label: "Cliente",
          field: "corporateName",
          tdClass: "align-middle"
        },
        {
          label: "E-mail",
          field: "recipient1",
          tdClass: "align-middle"
        },
        {
          label: "Pago",
          field: "paid",
          tdClass: "align-middle"
        },
        {
          label: "Nosso Número",
          field: "nossoNumero",
          tdClass: "align-middle"
        },
        {
          label: "Status",
          field: "status",
          tdClass: "align-middle"
        },
        {
          label: "Ação",
          field: "action",
          tdClass: "align-middle"
        },
      ];
    },
    async sendInvoiceByEmail(id) {
      try {
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/invoice/sendInvoiceByEmail`,
          { id }
        );
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Enviado",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel enviar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      this.loadInvoices();
    },
    async loadInvoices() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/invoice/getInvoicesNotSent`);
        this.invoices = response.data;
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.loadInvoices();
    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>